<template>
  <div>
    <loader v-if="loading"></loader>
    <div v-else>
      <div v-if="session.application_session && labelData!=null && labelData.created == false || (companyData && !companyData.email)">
       <h2 class="text-red text-lg text-bold mb-5 pb-2 uppercase">{{ $t('requests.msg_no_company') }}</h2>
        <sp-button
                theme="outline-blue"
                space="small"
                @click="CompanyLink"
                type="submit"
                :disabled = "(session.startup_application.user_id != session.user_auth.id)"
                :class="{'opacity-25 cursor-not-allowed': (session.startup_application.user_id != session.user_auth.id )}"
        >{{ $t('requests.link_company') }}</sp-button>
      </div>
      <div v-else>
        <h2
          class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b uppercase"
          v-if="(canApply || isStandardAdvantage) && allRequests.length>0"
        >{{ isStandardAdvantage ? $t('requests.avantages') : $t('requests.funding')}}</h2>

        <div
          v-if="saveMessage"
          class="alert alert-success bg-green-light border border-green text-sm text-green px-4 py-3 rounded relative mb-4"
        >{{ $t('requests.success') }}</div>
        <div
          v-if="messageCompany"
          class="alert alert-success bg-green-light border border-green text-sm text-green px-4 py-3 rounded relative mb-4"
        >{{ $t('company.messageCompany') }}</div>

        <div v-if="requests">
            <div v-if="session.startup_application.user_id == session.user_auth.id">
              <div v-if="this.isStandardAdvantage">
               <h3 class="mb-8">{{ $t('requests.advantage_pending') }}</h3>
               <p class="mb-4">{{ $t('requests.msg_pending') }}</p>
           
            <div v-if="requests.default_request">
              <div class="bg-white shadow-md rounded my-6">
                <table class="text-left w-full border-collapse">
                  <!--Border collapse doesn't work on this site yet but it's available in newer tailwind versions -->
                  <thead>
                    <tr>
                      <th
                        class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                      >{{ $t('requests.advantage_label') }}</th>
                      <th
                        class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                      >{{ $t('requests.valid_until') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="hover:bg-grey-lighter"
                      v-for="(lab, index) in requests.default_request"
                      :key="index"
                    >
                      <td class="py-4 px-6 border-b border-grey-light">{{lab.label}}</td>
                      <td
                        class="py-4 px-6 border-b border-grey-light"
                      >{{new Date(lab.available_to)| dateFormat('DD/MM/YYYY')}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
              </div>
            
          </div>
          <div v-if="this.isStandardAdvantage">
            <h3 class="mb-8" v-if="allRequests.length>0">{{ $t('requests.advantage_request') }}</h3>
          <p class="mb-4" v-if="allRequests.length>0">{{ $t('requests.benefits_are_available') }}</p>
          </div>
          <div class="bg-white shadow-md rounded my-6" v-if="(canApply || this.isStandardAdvantage) && allRequests.length>0">
            <table class="text-left w-full border-collapse">
              <thead v-if="this.isStandardAdvantage">
                <tr>
                  <th
                    class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                  >{{ $t('requests.advantage_type') }}</th>
                  <th
                    class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                  ></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="hover:bg-grey-lighter"
                  v-for="(lab, index) in allRequests"
                  :key="index"
                >
                  <td class="py-4 px-6 border-b border-grey-light" v-if="lab.id != 20">{{lab.label}}
                  <span v-if="lab.id==3" class="block my-2 text-red">{{ $t('requests.limit_date_conge') }} : {{lab.date_limit}}</span>
                  <span v-if="lab.id==4 && lab.date_limit" class="block my-2 text-red">{{ $t('requests.limit_date_bourse') }} : {{lab.date_limit}}</span>
                  </td>
                  <td class="py-4 px-6 border-b border-grey-light" v-if="lab.formCode === 'REQUEST_FORM_CNSS'">
                     <sp-button
                      theme="outline-blue"
                      space="small"
                      @click="applyRequest(lab.id)"
                      type="submit" v-if="companyData.cnss_affiliation_number != null"
                      :floatedToRight="true"
                    >{{ $t('requests.make_request') }}</sp-button>

                    <sp-button
                            theme="outline-blue"
                            space="small"
                            @click="CompanyLink"
                            type="submit" v-if="companyData.cnss_affiliation_number == null"
                            :disabled = "(session.startup_application.user_id != session.user_auth.id)"
                            :class="{'opacity-25 cursor-not-allowed': (session.startup_application.user_id != session.user_auth.id )}" 
                            :floatedToRight="true"
                    >{{ $t('requests.enter_cnss_affiliation') }}</sp-button>
                    
                  </td>
                  <td class="py-4 px-6 border-b border-grey-light" v-else-if="lab.id != 20">
                    <sp-button
                            theme="outline-blue"
                            space="small"
                            @click="applyRequest(lab.id)"
                            type="submit"
                            :floatedToRight="true"
                    >{{ isStandardAdvantage ? $t('requests.make_request') : $t('requests.make_funding_request')}}</sp-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else-if="!this.isStandardAdvantage && !canApply"
           class="alert alert-success bg-green-light border border-green text-sm text-green px-4 py-3 rounded relative mb-4">
           {{ $t('requests.funding_hidden_and_without_req') }}
          </div>
          <div v-if="stopRequests.length && this.isStandardAdvantage">
            <h3 class="mb-8">{{ $t('requests.stop_or_extend_advantage') }}</h3>
            <div class="bg-white shadow-md rounded my-6">
              <table class="text-left w-full border-collapse">
                <thead v-if="this.isStandardAdvantage">
                  <tr>
                    <th
                      class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                    >{{ $t('requests.advantage_type') }}</th>
                    <th
                      class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                    ></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="hover:bg-grey-lighter"
                    v-for="(stopRequest, index) in stopRequests"
                    :key="index"
                  >
                    <td class="py-4 px-6 border-b border-grey-light" v-if="stopRequest.id != 14">{{stopRequest.label}}
                      <span v-if="leaveRequestExist && stopRequest.id == 14" class="block my-2 text-red">{{ $t('requests.limit_date_extend_leave') }} : {{ leaveRequestExist }}</span>
                    </td>
                    <td class="py-4 px-6 border-b border-grey-light" v-if="stopRequest.id == 12">
                      <sp-button
                        theme="outline-blue"
                        space="small"
                        @click="applyRequest(stopRequest.id, stopRequest.startBourseDate,stopRequest.endBourseDate)"
                        type="submit"
                        :floatedToRight="true"
                        :disabled="stopRequest.status"
                      >{{ $t('requests.stop_request') }}</sp-button>
                    </td>
                    <td class="py-4 px-6 border-b border-grey-light" v-else-if="stopRequest.id != 14">
                      <sp-button
                        theme="outline-blue"
                        space="small"
                        @click="applyRequest(14, stopRequest.startLeaveDate)"
                        type="submit"
                        :floatedToRight="true"
                        :disabled="disableLeaveOrExtendLeave(14) || (leaveRequestExist && !(new Date(leaveRequestExist.split('/').reverse().join('-')).toISOString().slice(0, 10) >=  new Date().toISOString().slice(0, 10)))"
                      >{{ $t('requests.extend_request') }}</sp-button>
                      <sp-button
                        theme="outline-blue"
                        space="small"
                        @click="applyRequest(13)"
                        type="submit"
                        :floatedToRight="true"
                        :disabled="disableLeaveOrExtendLeave(13)"
                      >{{ $t('requests.stop_request') }}</sp-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- <h2
                class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b uppercase"
        >{{ $t('requests.my_requests') }}</h2> -->
        <tabs :standard-advantage="this.isStandardAdvantage"></tabs>
      </div>
    </div>
  </div>
</template>

<style>
table.border-separate {
  border-spacing: 0 10px;
}

table.border-separate tbody tr {
  box-shadow: 0 2px 4px 0 rgba(29, 57, 100, 0.16);
  border-radius: 4px;
}

table.border-separate tbody tr:hover {
  box-shadow: 0 4px 8px 0 rgba(22, 66, 132, 0.19);
}

.table.border-separate tbody td {
  vertical-align: middle;
  border-color: rgba(29, 57, 100, 0.13);
}

.table.border-separate tbody tr:hover td {
  border-color: rgba(29, 57, 100, 0.23);
}

.table.border-separate thead th,
.table.border-separate thead td {
  border: none;
}
</style>

<script>
import ApiService from "@/common/api.service";
import { mapGetters, mapState } from "vuex";
import { FETCH_APPLICATION, CLEAR_SAVE_MESSAGE, CHECK_LABEL } from "@/store/actions.type";
import ButtonVue from "../../components/spKit/Button.vue";

import store from "@/store";
import CompanyVue from "../../components/pages/Company.vue";
import Tabs from "../../components/Candidat/Tabs.vue";
import {
  SET_LabelApp,
  SET_LabelMenuActive,
  SET_HashId,
  SET_START_LEAVE_DATE,
  SET_START_BOURSE_DATE,
  SET_END_BOURSE_DATE
} from "@/store/mutations.type";
import Loader from "@/components/Loader.vue";

export default {
  name: "avantages",
  components: {
    "sp-button": ButtonVue,
    company: CompanyVue,
    tabs: Tabs,
    Loader
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(CLEAR_SAVE_MESSAGE);
    next();
  },
  props: {
    isStandardAdvantage: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      requests: null,
      checkApp: false,
      labelData: null,
      loading: true,
      messageCompany: false,
      companyData: null,
      companyData: null,
      canApply: true,
      allRequests: [],
      stopRequests: []
    };
  },
  mounted() {
    if (this.isStandardAdvantage) {
      this.$store.commit(SET_HashId,this.$route.params.app_id);
      this.$store.dispatch(CHECK_LABEL, this.hashId);
      if (this.session.startup_application == null) {
        this.$store.dispatch(FETCH_APPLICATION, this.$route.params.app_id).then(() => {
        this.checkLabel();
      })
    } else if (this.session.startup_application.label_ref) {
      this.checkLabel();
      }
    } else {
      this.checkLabel();
    }

  },
  methods: {
    applyRequest(id, date = null, date_end = null) {
      if (id == 14 && date) {
        this.$store.commit(SET_START_LEAVE_DATE, date);
      }
      if (id == 12 && date && date_end) {
        this.$store.commit(SET_START_BOURSE_DATE, date);
        this.$store.commit(SET_END_BOURSE_DATE, date_end);
      }
      let nameStr = ''
      this.isStandardAdvantage ? nameStr = "requestFrom" : nameStr = "requestFundingFrom"
      this.$router.push({
        name: nameStr,
        params: {
          ref: this.session.startup_application.label_ref,
          type_id: id
        }
      });
    },
    checkLabel() {
        if (this.session.startup_application.status != "9") {
          this.$router.push({name: "home"})
        }
        let application_ref = this.$route.params.app_id;
        ApiService.get(`/api/requests/check_label/${this.hashId}`)
            .then((data) => {
                if(data.data.data.application != null) {
                    this.$store.commit(SET_LabelMenuActive,1);
                    let label_ref = data.data.data.label_ref;
                    if (label_ref) {
                        ApiService.get(`/api/requests/verify/${label_ref}`)
                            .then(data => {
                                this.checkApp = true;
                                this.labelData = data.data.data;
                                this.companyData = this.labelData.company;
                                this.getLabel();
                            })
                            .catch(response => {
                                this.checkApp = false;
                                this.labelData = null;
                            });
                    }
                }else{
                    this.$store.commit(SET_LabelMenuActive,0);
                }
            })
            .catch(response => {
                this.$store.commit(SET_LabelMenuActive,0);
                this.$router.push({name: "home"})
            });
    },
    getLabel() {
      let url = null;
      this.requests = null
      this.isStandardAdvantage ? url = `/api/requests/${this.LabelApplication}` :  url = `/api/requests/${this.LabelApplication}/funding`
      ApiService.get(url)
        .then(data => {
          this.requests = data.data.data;
          this.allRequests = data.data.data.requests;
          this.stopRequests = data.data.data.stop_requests;
          var accepted_request = [];
          this.requests.accepted_request.forEach(function (value, key) {
              accepted_request.push(value.type_id);
          });
          if(accepted_request.includes(6)){
              this.requests.default_request;
          }else{
              this.requests.default_request.splice(1,1);
          }
          this.loading = false;
          if(!this.isStandardAdvantage && data.data.data.pendding_requests.length){
            this.canApply = false
          }
        })
        .catch(response => {
          this.requests = null;
        });
    },
    saveCompany(msg) {
      this.messageCompany = true;
      this.checkLabel();
    },
    CompanyLink() {
        this.$router.push({name: "Entreprise"})
    },

    disableLeaveOrExtendLeave(type) {
      let request = this.stopRequests.filter((stopRequest) => {
        return stopRequest.id == type
      });
      return request &&
        request[0] &&
        request[0].status
        ? request[0].status
        : false;
    }
  },
  computed: {
    ...mapGetters(["session","hashId","LabelApplication"]),
    ...mapState({
      saveMessage: state => state.request.saveMessage
    }),

    leaveRequestExist() {
      let extendLimitDate = this.stopRequests.filter((stopRequest) => {
        return stopRequest.id == 14
      });
      return extendLimitDate &&
        extendLimitDate[0] &&
        extendLimitDate[0].extendLimitDate
        ? extendLimitDate[0].extendLimitDate
        : null;
    }
  },
  watch: {
    isStandardAdvantage() {
      this.canApply = true
      this.checkLabel();
    }    
  }
};
</script>

<style>
</style>
